
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire958d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire958d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $6ZWSX = parcelRequire("6ZWSX");

var $dfFow = parcelRequire("dfFow");
parcelRequire("9NZOq");
const $7e97b05359617f07$var$systeme_iso = [
    "Oxyg&egrave;ne / Oxygen",
    "Hydrog&egrave;ne / Hydrogen",
    "Carbone / Carbon",
    "Soufre / Sulfur"
];
window.Buffer = (0, $6ZWSX.Buffer);
async function $7e97b05359617f07$var$read_csv() {
    const response = await fetch("https://alphadelta.ggl.ulaval.ca/data/rres.csv", {
        method: "GET"
    }).catch((error)=>{
        console.log(error);
    });
    const fileContent = await response.text();
    // break the textblock into an array of lines
    let contentTab = fileContent.split("\n");
    // remove one line, starting at the first position
    contentTab.splice(0, 1);
    // join the array back into a single string
    let contentWithoutFirstLine = contentTab.join("\n");
    return $dfFow.parse(contentWithoutFirstLine, {
        delimiter: ";"
    });
}
function $7e97b05359617f07$var$add_table(csvParsed) {
    let data = "";
    let i = 0;
    for(const isystem in $7e97b05359617f07$var$systeme_iso){
        data += "<p><H3> " + $7e97b05359617f07$var$systeme_iso[isystem] + "</H3>";
        const v = "id=table_" + isystem + ">";
        data += '<select NAME="-e" SIZE="7"' + v + "\n";
        for (const param of csvParsed){
            const desc1 = param[6];
            const desc2 = param[7];
            const desc3 = param[8];
            const test = param[11];
            const fisysteme = parseInt(test);
            if (parseInt(isystem) + 1 === fisysteme) {
                data += '<option VALUE="' + i + '">' + desc1 + ";" + desc2 + ";" + desc3 + "\n";
                i = i + 1;
            }
        }
        data += "</select>\n";
    }
    return data;
}
async function $7e97b05359617f07$var$main() {
    let str = "";
    const csvText = await $7e97b05359617f07$var$read_csv();
    str += $7e97b05359617f07$var$add_table(csvText);
    return str;
}
let $7e97b05359617f07$var$promise = new Promise(function(resolve, reject) {
    let result = $7e97b05359617f07$var$main();
    resolve(result);
});
$7e97b05359617f07$var$promise.then((result)=>{
    document.getElementById("testid").innerHTML = result;
    document.getElementById("table_0").value = "";
    document.getElementById("table_1").value = "";
    document.getElementById("table_2").value = "";
    document.getElementById("table_3").value = "";
});


//# sourceMappingURL=temp_select_page.2fbd2243.js.map
